import { NgModule } from '@angular/core';
import { IconButtonModule } from '../../../shared/directives/icon-button/icon-button.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { PdfFooterComponent } from './pdf-footer.component';
import { PdfSpacerModule } from '../pdf-spacer/pdf-spacer.module';


@NgModule({
  declarations: [
    PdfFooterComponent
  ],
  exports: [
    PdfFooterComponent
  ],
  imports: [
    IconButtonModule,
    CommonModule,
    TranslateModule,
    DragDropModule,
    PdfSpacerModule
  ],
  providers: []
})
export class PdfFooterModule { }
